import { useState } from 'react';
import PageHero from '../components/PageHero';
import Reveal from '../components/Reveal';
import banner from '../assets/images/burj-al-arab.jpg';

const GOOGLE_SHEETS_WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbztEQz0-hQpP0GREjv3dmf1RvXXgb7zT2qwidNy5tCiyV5My7BN3CoU0PJdkoqATeZrKA/exec';

export default function Contact() {
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    setSent(false);
    setError('');

    const body = new URLSearchParams();
    new FormData(form).forEach((value, key) => body.append(key, String(value)));

    setSubmitting(true);
    try {
      // Apps Script does not provide browser-readable CORS headers, so this is a
      // fire-and-forget request.
      await fetch(GOOGLE_SHEETS_WEBHOOK_URL, { method: 'POST', mode: 'no-cors', body });
      form.reset();
      setSent(true);
    } catch {
      setError('We could not send your enquiry. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <PageHero
        image={banner}
        eyebrow="Contact"
        title="Start a conversation."
        lead="Tell us what you're looking for, or what you're looking to sell or lease. We reply within 1–3 business days."
        action={{ href: '#enquiry-form', label: 'Book a consultation' }}
      />

      <section className="section">
        <div className="wrap grid gap-16 md:grid-cols-[0.85fr_1.15fr] md:gap-20">
          <Reveal>
            <h2 className="text-[2rem]">Contact us</h2>
            <span className="rule mt-5" />
          </Reveal>

          <Reveal delay={150}>
            <form id="enquiry-form" onSubmit={onSubmit} className="grid scroll-mt-28 gap-5 rounded-sm bg-paper p-6 shadow-[0_30px_60px_-30px_rgba(21,20,15,0.25)] md:p-10">
              <div className="grid gap-5 sm:grid-cols-2">
                <div><label className="label" htmlFor="name">Full name</label><input className="field" id="name" name="name" required /></div>
                <div><label className="label" htmlFor="phone">Phone</label><input className="field" id="phone" name="phone" type="tel" required /></div>
              </div>
              <div className="grid gap-5 sm:grid-cols-2">
                <div><label className="label" htmlFor="email">Email</label><input className="field" id="email" name="email" type="email" required /></div>
                <div>
                  <label className="label" htmlFor="reason">I'm looking to</label>
                  <select className="field" id="reason" name="reason" required defaultValue="">
                    <option value="" disabled>Select an option</option>
                    <option>Buy</option><option>Sell</option><option>Rent</option><option>Lease out a property</option><option>Get investment advice</option>
                  </select>
                </div>
              </div>
              <div>
                <label className="label" htmlFor="message">Tell us more</label>
                <textarea className="field min-h-[130px] resize-y" id="message" name="message" placeholder="e.g. 2-bed apartment, Dubai Marina, budget AED 3–4M" required />
              </div>
              <div className="sr-only" aria-hidden="true">
                <label htmlFor="website">Leave this field empty</label>
                <input id="website" name="website" tabIndex={-1} autoComplete="off" />
              </div>
              <div className="flex flex-wrap items-center gap-4">
                <button type="submit" className="btn btn-primary cursor-pointer" disabled={submitting}>
                  {submitting ? 'Sending…' : 'Send enquiry'}
                </button>
                <span className="text-sm text-ink/70" role="status" aria-live="polite">
                  {error || (sent ? 'Thanks — your enquiry was sent. We’ll respond within 1–3 business days.' : "We'll respond within 1–3 business days.")}
                </span>
              </div>
            </form>
          </Reveal>
        </div>
      </section>
    </>
  );
}
